export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-2xl text-background-50 mb-3 block">私密视频</span>
            <p className="text-xs text-background-50/50 leading-relaxed">
              私密视频品牌提供红桃视频、西瓜视频免费、小蓝视频、茄子视频、久久视频、
              芒果视频等综合平台免费在线观看，高清画质不缓冲，全集资源一站畅享。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-home-line text-sm text-background-50/60"></i>
              </a>
              <a href="#carousel" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-fire-line text-sm text-background-50/60"></i>
              </a>
              <a href="#ranking" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-trophy-line text-sm text-background-50/60"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm text-background-50/60"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门频道</h4>
            <ul className="space-y-2.5">
              <li><a href="#carousel" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">红桃视频专区</a></li>
              <li><a href="#carousel" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">西瓜视频免费</a></li>
              <li><a href="#carousel" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">小蓝视频热播</a></li>
              <li><a href="#carousel" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">茄子视频推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快捷导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
              <li><a href="#faq" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
              <li><a href="#comments" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">用户口碑</a></li>
              <li><a href="#updates" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">最新动态</a></li>
              <li><a href="#app" className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">移动端体验</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <ul className="space-y-2.5">
              <li><span className="text-xs text-background-50/40">内容合作方入驻中</span></li>
              <li><span className="text-xs text-background-50/40">品牌合作持续拓展</span></li>
              <li><span className="text-xs text-background-50/40">版权合作洽谈开放</span></li>
            </ul>
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 mt-4 text-xs text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
            >
              <i className="ri-add-circle-line"></i>
              <span>成为合作伙伴</span>
            </a>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/30">
            &copy; 2026 私密视频. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-50/30">红桃视频</span>
            <span className="text-xs text-background-50/30">西瓜视频免费</span>
            <span className="text-xs text-background-50/30">小蓝视频</span>
            <span className="text-xs text-background-50/30">茄子视频</span>
            <span className="text-xs text-background-50/30">久久视频</span>
            <span className="text-xs text-background-50/30">芒果视频</span>
          </div>
        </div>
      </div>
    </footer>
  );
}